module.exports = "/lucky-balls/img/bonus_green/ball_holder.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/ball_holder.png
// module id = 922
// module chunks = 0